import { ActionContext } from 'vuex';
import { RootState } from '@/store/store';
import { siteApi } from '@/api/site.api';
import { SiteState, Site, SiteInfo, GetSitesPayload } from './types/site.types';

export const siteActions = {
  async getSites(
    store: ActionContext<SiteState, RootState>,
    params: GetSitesPayload,
  ) {
    try {
      store.commit('GET_SITE_LOADING');
      const { data } = await siteApi.getSites(params);
      const result: SiteInfo = data;
      store.commit('GET_SITE_SUCCESS', result);
    } catch (error) {
      store.commit('GET_SITE_ERROR', error);
    }
  },
  async addNewSite(store: ActionContext<SiteState, RootState>, newSite: Site) {
    try {
      store.commit('ADD_SITE_LOADING');
      const { data } = await siteApi.addNewSite(newSite);
      const result: SiteInfo = data;
      store.commit('ADD_SITE_SUCCESS', result);
      return result;
    } catch (error) {
      store.commit('ADD_SITE_ERROR', error);
    }
  },
  async deleteSite(store: ActionContext<SiteState, RootState>, id: number) {
    try {
      store.commit('DELETE_SITE_LOADING');
      await siteApi.deleteSite(id);
      store.commit('DELETE_SITE_SUCCESS', id);
    } catch (error) {
      store.commit('DELETE_SITE_ERROR', error);
    }
  },
  async editSite(
    store: ActionContext<SiteState, RootState>,
    updatedSite: Site,
  ) {
    try {
      store.commit('EDIT_SITE_LOADING');
      const { data } = await siteApi.editSite(updatedSite);
      const result: SiteInfo = data;
      store.commit('EDIT_SITE_SUCCESS', result);
    } catch (error) {
      store.commit('EDIT_SITE_ERROR', error);
    }
  },
};
